import axiosInstance from "../../lib/axiosInstance";

export const getMe = async () => {
  const response = await axiosInstance.get("/me");
  return response?.data;
};

export const getUserById = async (id) => {
  const response = await axiosInstance.get(`/get_user/${id}`);
  return response?.data?.user ?? response?.data;
};

export const updateUserById = async (id, fields = {}) => {
  const response = await axiosInstance.patch(`/update_user/${id}`, fields);
  return response?.data;
};
